var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 74,
    viewBox: "0 0 204 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.273 43.0935C64.6585 32.6916 29.5725 40.1215 0 53V0H204V34.6729C172.322 49.3346 125.307 46.2252 111.273 43.0935Z",
    fill: "#045481"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106 48.6189C56.4 39.4189 14.6667 58.7855 0 69.6189V73.6189C40 47.6189 87.3333 46.1189 106 48.6189Z",
    fill: "#045481"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107 45.6188C60.5 35.1189 17.3333 49.9522 0 58.6188V64.1187C39.5 39.1189 89.5 42.7806 107 45.6188Z",
    fill: "#045481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 46.5C165.5 52 189 44.5 204 38.5V42.5C170.5 52.5 133.5 50 119.5 46.5Z",
    fill: "#045481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119 49.5C157 57.5 191.5 51.5 204 46.5V51.5C164 60 130 52.5 119 49.5Z",
    fill: "#045481"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/Shape 1.92e5943b0da6c1dd4003a8edf759aabd.svg";
export { ForwardRef as ReactComponent };